var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.912231,
    width: 44,
    height: 44,
    rx: 22,
    fill: "url(#paint0_linear_1_7488)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0191 21.1852L18.596 14.3532C15.875 12.7252 12.8022 15.8502 14.4752 18.5442L16.6341 22.0202C16.6891 22.1082 16.785 22.1622 16.889 22.1622H23.0001C23.4101 22.1622 23.7501 22.5022 23.7501 22.9122C23.7501 23.3222 23.4101 23.6622 23.0001 23.6622H16.888C16.784 23.6622 16.6881 23.7162 16.6331 23.8042L14.4742 27.2802C12.8012 29.9742 15.874 33.0992 18.595 31.4712L30.0181 24.6392C31.3251 23.8582 31.3251 21.9662 30.0191 21.1852Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_7488",
    x1: 0,
    y1: 0.912231,
    x2: 47.4765,
    y2: 2.52542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3AEB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9505F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCta);
export default __webpack_public_path__ + "static/media/CTA.543d40a7e186b326eadae6c20af03093.svg";
export { ForwardRef as ReactComponent };